export const MAP_MIN_ZOOM = 8;
export const MAP_MAX_ZOOM = 20;
export const MAP_DEFAULT_ZOOM = 12;
export const MAP_SEARCH_DELAY_SEC = 3;
